(function() {
    'use strict';
    /**
     *
     * Enhance tabs. Add functionality to a tabs element.
     *
     * It should be define as
     *      <ul id="tabsElementId" data-role="tabs">
     *          <li class="active">Item1</li>
     *          <li>Item2</li>
     *          <li>Item3</li>
     *          (...)
     *      </ul>
     *
     *
     * It will enhance to
     *      <ul id="tabsElementId" data-role="tabs" data-skip-enhance="true" data-active-tab="0">
     *          <li data-index="0" class="active">Item1</li>
     *          <li data-index="1">Item2</li>
     *          <li data-index="2">Item2</li>
     *          (...)
     *      </ul>
     *
     *
     *  Returns: When tabs changes it will trigger the event "change", in the second argument it has the index of the new state (-1 if empty)
     *
     * @param {Jquery} $ul Jquery object for unordered list that
     * @param {Object} newoptions object with properties:
     *              allowEmptySelection - If true, it allow to set all tabs as non active. Otherwise one is always active
     *              panelSelector - If set, the panels container
     * @return {*}
     */
    Odigeo.UIElements.enhanceTabs = function($ul, newoptions) {
        var globalOptions = {
            defaultTab: 'gallery',
        };

        var globalSelectors = {
            hiddenClass: 'odf-hidden',
            tabPanel: '.tab_panel',
            dataActiveTab: 'data-active-tab',
            activeClass: 'active',
        };

        var $UiEl = ($ul instanceof $) ? $ul : $($ul);
        var options = Odigeo._.extend({}, globalOptions, newoptions);
        var $panelSelector = $(options.panelSelector);
        var handler;

        var checkEveryTab = function() {
            return Odigeo._.reduce($UiEl, function(memo, tab) {
                return memo && $(tab).attr('data-skip-enhance') === 'true';
            }, true);
        };

        // Check if UiElement has everything ok to be created
        if (Odigeo._.isEmpty($UiEl) || !($UiEl instanceof $) || $UiEl.attr('data-role') !== 'tabs' ||
            checkEveryTab()) {
            return;
        }

        // Initialize
        $UiEl.attr(globalSelectors.dataActiveTab, -1);
        options.allowEmptySelection = (options.allowEmptySelection === true || options.allowEmptySelection === 'true');

        var setIndexTo = function($el, element, classToFind, attr, hasClass) {
            $el.find(element).each(function(index) {
                $(this).attr('data-index', index);
                if ($(this).hasClass(classToFind) === hasClass) {
                    $el.attr('data-active-' + attr, index);
                }
            });
        };

        var togglePanel = function($panel, toggle) {
            $panel.toggleClass(globalSelectors.hiddenClass, toggle === 'hide');
        };

        var togglePanelWithIndex = function(index, toggle) {
            Odigeo._.forEach($panelSelector, function(item) {
                togglePanel($(item).find(globalSelectors.tabPanel).eq(index), toggle);
            });
        };

        var togglePanelWithName = function(name, toggle) {
            togglePanel($panelSelector.find('.panel_' + name), toggle);
        };

        var hideActivePanel = function() {
            togglePanelWithIndex(getActivePanelIndex(), 'hide');
        };

        var showActivePanel = function() {
            togglePanelWithIndex(getActivePanelIndex(), 'show');
        };

        var getActivePanelIndex = function() {
            return parseInt($panelSelector.attr('data-active-panel'), 10);
        };

        var getTabs = function() {
            return $UiEl.find('li');
        };

        var getPanel = function(panel) {
            var $tabs = getTabs();

            if ($tabs.length === 0) {
                return null;
            }

            if ($tabs.filter('[data-panel="' + panel + '"]').length) {
                return panel;
            } else {
                return getPanel(getNextPanel(panel));
            }
        };

        var getDataPanels = function() {
            return getTabs().map(function(index, item) {
                return $(item).attr('data-panel');
            });
        };

        var getNextPanel = function(panel) {
            var dataPanels = getDataPanels();
            var index = Odigeo._.indexOf(dataPanels, panel);

            return ++index < dataPanels.length ? dataPanels[index] : dataPanels[0];
        };

        var setActivePanelIndex = function() {
            $panelSelector.attr('data-active-panel', 0);
            $panelSelector.find(globalSelectors.tabPanel).addClass(globalSelectors.hiddenClass);
            $UiEl.find('li.active').removeClass(globalSelectors.activeClass);
        };

        var setActiveTab = function(panel) {
            $UiEl.find('li.active').removeClass(globalSelectors.activeClass);
            var activeTab = $UiEl.find('li').filter(function(index, item) {
                return $(item).attr('data-panel') === panel;
            }).toggleClass(globalSelectors.activeClass);
            $UiEl.attr('data-active-tab', activeTab.attr('data-index'));
            $panelSelector.attr('data-active-panel', activeTab.attr('data-index'));
        };

        var setDefaultPanel = function(defaultTab) {
            if (defaultTab !== globalOptions.defaultTab) {
                togglePanelWithIndex(0, 'hide');
                setActiveTab(defaultTab);
                togglePanelWithName(defaultTab, 'show');
            }
            Odigeo._.forEach($panelSelector, function(item) {
                setIndexTo($(item), globalSelectors.tabPanel, globalSelectors.hiddenClass, 'panel', false);
            });
        };
        Odigeo._.forEach($UiEl, function(item) {
            setIndexTo($(item), 'li', globalSelectors.activeClass, 'tab', true);
        });
        setDefaultPanel(options.defaultTab);

        $UiEl.attr({'data-skip-enhance': true});

        // INTERFACE EVENT DECLARATION
        // Bind tap event
        $UiEl.on(Odigeo.Events.tap, 'li', function() {
            var el = $(this);
            if (options.allowEmptySelection || !el.hasClass(globalSelectors.activeClass)) {
                $UiEl.find('li.active').not(this).removeClass(globalSelectors.activeClass);
                el.toggleClass(globalSelectors.activeClass);
                hideActivePanel();

                var actualIndex = el.attr('data-index');
                // Set data-active-tab and panel
                $UiEl.attr(globalSelectors.dataActiveTab,
                    (el.hasClass(globalSelectors.activeClass)) ? actualIndex : -1);
                $panelSelector.attr('data-active-panel', actualIndex);
                showActivePanel();

                // Trigger track change event
                var $elementToTrigger = options.allowEmptySelection ? $UiEl : $UiEl.find('li.active');
                $elementToTrigger.trigger('change', parseInt($UiEl.attr(globalSelectors.dataActiveTab), 10));
            }
        });

        // Todo: make test for this
        // Bind set tab in Modified style. If idx is undefined, it will modify the style of every tab
        $UiEl.on('setStyleModified', function(ev, idx) {
            var indexString = (!Odigeo._.isUndefined(idx)) ? '[data-index=' + idx + ']' : '';
            $(this).find('li' + indexString).toggleClass('applied', true);
        });

        // Todo: make test for this
        // Bind set tab in default style. If idx is undefined, it will modify the style of every tab
        $UiEl.on('setStyleDefault', function(ev, idx) {
            var indexString = (!Odigeo._.isUndefined(idx)) ? '[data-index=' + idx + ']' : '';
            $(this).find('li' + indexString).toggleClass('applied', false);
        });

        handler = {
            getPanel: function(panel) {
                return Odigeo._.bind(getPanel, this, panel)();
            },
            setActivePanelIndex: function() {
                return Odigeo._.bind(setActivePanelIndex, this)();
            },
            togglePanelWithName: function(panel, toggle) {
                return Odigeo._.bind(togglePanelWithName, this, panel, toggle)();
            },
            hideActivePanel: function() {
                return Odigeo._.bind(hideActivePanel, this)();
            },
            setActiveTab: function(panel) {
                return Odigeo._.bind(setActiveTab, this, panel)();
            },
        };

        return handler;
    };
}());
